import { render, staticRenderFns } from "./baiduAI.vue?vue&type=template&id=e8905cd2&scoped=true"
import script from "./baiduAI.vue?vue&type=script&lang=js"
export * from "./baiduAI.vue?vue&type=script&lang=js"
import style0 from "./baiduAI.vue?vue&type=style&index=0&id=e8905cd2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8905cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8905cd2')) {
      api.createRecord('e8905cd2', component.options)
    } else {
      api.reload('e8905cd2', component.options)
    }
    module.hot.accept("./baiduAI.vue?vue&type=template&id=e8905cd2&scoped=true", function () {
      api.rerender('e8905cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/baiduAI.vue"
export default component.exports